import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingController, ToastController } from '@ionic/angular';
import { VendorBackendService } from '../../core/services/vendor-services/vendor-backend.service';
import { CustomPasswordValidators } from './custom-password-validators';
import jwt_decode from "jwt-decode";
import { AppRouterService } from '../../core/services/app-router.service';
import { HelperService } from '../../core/services/helper.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.page.html',
  styleUrls: ['./set-password.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SetPasswordPage implements OnInit {

  setPasswordform: UntypedFormGroup;
  submitted: boolean = false;
  securityQuestions:any;
  token: any;
  regemail: any;

  constructor(
    private fb: UntypedFormBuilder,
    private backendService: VendorBackendService,
    private route: ActivatedRoute,
    public toastController: ToastController,
    private appRouter: AppRouterService,
    public loadingController: LoadingController,
    public helperService: HelperService
  ) { }


  ngOnInit() {
    this.setPasswordform = this.fb.group({
      'newPassword': [
        '',
        Validators.compose([
          Validators.required,
          // check whether the entered password has a number
          CustomPasswordValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          // check whether the entered password has a upper case letter
          CustomPasswordValidators.patternValidator(/[A-Z]/, {
            hasUpperCase: true 
          }),
          // check whether the entered password has a lower case letter
          CustomPasswordValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
          // check whether the entered password has a special character
          CustomPasswordValidators.patternValidator(
            /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
            {
              hasSpecialCharacters: true
            }
          ),
          Validators.minLength(8)
        ])
      ],
      'confirmPassword': [
        '',
        Validators.compose([Validators.required])
      ],
      'securityQuestion': ['', Validators.required],
      'securityAnswer': ['', Validators.required]
    },{
      // check whether our password and confirm password match
      validator: CustomPasswordValidators.passwordMatchValidator
    });
    this.route.queryParams
      .subscribe(params => {
        this.token = params.data;
      }
    );
    var decodeToken: any = this.getDecodeToken(this.token);
    if(decodeToken) {
      this.regemail = decodeToken.email;
    }
    this.backendService.Get('securityQuestions').subscribe(
      data => { this.securityQuestions = data }
    );
  }
  hide = true;
  get setPasswordControls() { return this.setPasswordform.controls; }

  onSetPasswordSubmit() {
    this.submitted = true;
    // //console.log(this.setPasswordform.value);
    if (this.setPasswordform.invalid) {
      return;
    }
    this.route.queryParams
      .subscribe(params => {
        this.token = params.data;
      }
    );
    var decodeToken: any = this.getDecodeToken(this.token);
    if(decodeToken) {
      var refId = decodeToken.id;
      var refemail = decodeToken.email;
      let setPasswordObj = {
        id: refId,
        email : refemail,
        questId: this.setPasswordform.value.securityQuestion,
        answer: this.setPasswordform.value.securityAnswer,
        password: this.setPasswordform.value.newPassword.trim()
      }
      this.helperService.loader();
      this.backendService.Post('setPassword', setPasswordObj)
        .subscribe(
          data => {
            this.helperService.closeLoader().then(()=>{
              this.submitted = false;
              this.helperService.presentToast('Password set successfully.', 2000);
              this.appRouter.gotoPath('vendor/login');
            })
          },
          error => {
            this.helperService.closeLoader().then(()=>{
              this.helperService.presentToast(error.error, 2000);
            })
          }
      );
    } else {
      this.helperService.closeLoader().then(()=>{
        this.submitted = false;
        this.helperService.presentToast('Something went wrong please try again later.', 2000);
      })
    }
  }
  
  getDecodeToken (token: any) {
    if(token) {
      var decoded = jwt_decode(token);
      return decoded;
    }
    return;
  }
}
